import { AuthContextUserType } from '@sparelabs/context-propagation'
import { GenericResource, IHttpAgent, IListModelQueryParamValues } from '@sparelabs/http-client-utils'
import { PermissionType } from '@sparelabs/permissions'
import { IAuthorizationPermissionsResponse, Resources } from '../types'

export class AuthorizationPermissionResource extends GenericResource<
  IAuthorizationPermissionsResponse,
  IListModelQueryParamValues,
  unknown,
  unknown
> {
  constructor(agent: IHttpAgent) {
    super(Resources.AuthorizationPermission, agent)
  }

  public async loadUserPermissions(userId: string, userTypes: AuthContextUserType[]): Promise<PermissionType[]> {
    const { data } = await this.agent.get<IAuthorizationPermissionsResponse>(
      `${Resources.AuthorizationPermission}/${userId}`,
      { params: { userTypes: userTypes ?? [] } },
    )

    return data.permissions
  }
}
